import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';

const savedLanguage = localStorage.getItem('language');

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .use(Backend)
  .init({
    lng: savedLanguage || undefined,
    fallbackLng: 'fr',
    debug: true,
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json?v=' + (import.meta.env.VITE_VERSION || Date.now()),
      // Disable i18next cache to always fetch fresh translations
      requestOptions: {
        cache: 'no-store',
      },
    },
  });
  
